import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getIsNewNavigation } from 'containers/Header/selectors';
import { getAssetBarRecord } from '../../selectors/detailPage/epgChannel';
import RecordBarStatus from 'containers/_Shared/RecordBarStatus';
import { fetchChannelsWithOptions } from 'action-creators/epg';
import { getUserId } from 'utils/User';
import { getCurrentNode, getNodesEnriched } from '../../reducers/nav/selectors';
import * as infinite from '../../action-creators/infinite';
import * as actions from '../../actions/response';
import * as constants from './constants';
import PosterFormatType from '../posters/PosterFormatType';
import PosterTitle from '../posters/PosterTitle';
import HTMLDECODE from '../../utils/htmlDecode';
import Utils from '../../utils/Utils';
import { converter } from '../../helpers/converter';
import LoadingBlocks from '../forms/LoadingBlocks';
import Tooltip from './ToolTip';
import * as actionsMetrics from '../../action-creators/metrics';
import { GetRegion, PLAYER_SEGMENT } from '../../constants';
import LoadingSpinner from '../forms/LoadingSpinner';
import FiltersContainer from '../navigation-filters/filters-container';
import ClaroUrlBuilder from '../../utils/ClaroUrlBuilder';
import NavigationWrapper from '../NavigationWrapper';
import { checkIfChannelIsBlocked } from 'containers/EPG/actions/channelBlocker/blocker.actions';
import { SubMenu } from 'containers/Menu/SubMenu';
import { getContentListV1 } from 'utils/homologacion/homologacion';
class InfiniteList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      from: 0,
      empty: 0,
      level: null,
      args: {},
      fox: {},
      isFox: false,
      total: 0,
      isNodeTV: false,
      orderOpt: ['200', 'ASC'],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event, opt) {
    const order = opt.order.split('-');
    this.setState({
      orderOpt: order,
    });
    const { infiniteListData } = this.props;
    const args = Object.assign({}, this.state.args);
    const orderOpts = { order_way: order[1], order_id: order[0] };
    Object.keys(args).forEach(arg => {
      if (orderOpts[arg]) args[arg] = orderOpts[arg];
    });

    args.from = 0;
    this.setState({ args, from: 0 });

    infiniteListData(this.state.args, data => {
      this.setState({
        data: data.response.groups,
        empty: data.response.groups.length,
      });
    });
  }

  proccessTag(p) {
    const hasTitle = g => g.title !== undefined;
    const hasFormatTypes = g => g.format_types !== undefined;

    if (hasTitle(p) && !hasFormatTypes(p)) {
      return `${p.title} -`;
    }
    if (!hasTitle(p) && hasFormatTypes(p)) {
      return `${p.format_types} -`;
    }
    if (hasTitle(p) && hasFormatTypes(p)) {
      return `${p.format_types}-${p.title} -`;
    }
    return '';
  }

  proccessRoute() {
    if (this.props.location) {
      const route = this.props.location.pathname;
      const r = route.split('/');
      return r[2];
    }
  }

  setMetrics(data, key) {
    const eventCategory = constants.CAROUSEL;
    const tag = this.proccessTag(data);
    const route = this.proccessRoute();
    const eventAction = route;
    const eventLabel = `${tag} ${key}| ${constants.INFINITE_LIST}`;

    this.props.setMetricsEvent({
      tagManager: {
        event: eventCategory,
        eventCategory,
        eventAction,
        eventLabel,
      },
    });

    this.props.setMetricsEvent({
      type: constants.EXECUTOR,
      success: true,
    });
  }

  componentWillUnmount() {
    $(window).unbind(constants.SCROLL);
  }

  onHover(e, content, live) {
    if (e.target.className !== 'play' || live) {
      return;
    }

    const w = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0,
    );
    const h = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0,
    );
    let xoffset = 300;
    let yoffset = 80;

    if (e.target && e.target.clientWidth) {
      xoffset = e.target.clientWidth + 10;
      if (e.pageX > w - e.pageX) {
        xoffset = -e.target.clientWidth - 30;
      }
      if (e.pageY > h - e.pageY) {
        yoffset = -e.target.clientHeight - 30;
      }
    }

    const tooltip = <Tooltip tooltipData={content} x={xoffset} y={yoffset} />;
    this.setState({
      currentTooltip: {
        id: content.id,
        tooltip,
      },
    });
  }

  onOut() {
    const tooltip = <Tooltip />;
    this.setState({
      currentTooltip: {
        tooltip,
      },
    });
  }

  foxNodo() {
    const key = `nav_${this.props.currentNode.code}`;
    const keyRegion = `nav_${GetRegion()}_${this.props.currentNode.code}`;
    const exitKey =
      this.props.assets[`${key}_over`] ||
      this.props.assets[`${keyRegion}_over`];

    if (this.props.assets && exitKey) {
      const image = this.props.assets[keyRegion]
        ? this.props.assets[keyRegion]
        : this.props.assets[key];

      const imageOver = this.props.assets[`${keyRegion}_over`]
        ? this.props.assets[`${keyRegion}_over`]
        : this.props.assets[`${key}_over`];
      this.setState({
        isFox: true,
        fox: {
          image,
          image_over: imageOver,
        },
      });
    }
    return false;
  }

  onImageError(e) {
    e.target.src = constants.URL_IMAGE_ERROR_SMALL;
  }

  componentDidMount() {
    const { infiniteListData, query, config, levelList, node } = this.props;
    let eventToBind = constants.SCROLL;
    let pixelToSubstract = 150;

    if (Utils.MobileCheck()) {
      eventToBind = 'touchmove';
      pixelToSubstract = 400;
    }

    $(window).bind(eventToBind, () => {
      const screenCssPixelRatio = (window.outerWidth - 8) / window.innerWidth;
      if (screenCssPixelRatio < 1 || screenCssPixelRatio > 1) {
        const viewportHeight = $(window).height();
        const documentHeight = $(document).height() - pixelToSubstract;
        let isScrolling = $(document).scrollTop();

        isScrolling = Math.ceil(isScrolling + viewportHeight) >= documentHeight;
        const toNumber =
          parseInt(this.state.from, 10) + Number(this.state.args.quantity);
        if (isScrolling) {
          this.setState({ from: toNumber });
          this.state.args.from = this.state.from;

          if (this.state.empty > 0 && this.state.total > this.state.from) {
            infiniteListData(this.state.args, data => {
              this.setState({
                empty: data.response.groups.length,
                data: this.state.data.concat(data.response.groups),
              });
            });
          }
          if (this.state.total < this.state.from) {
            this.setState({ empty: 0 });
          }
        }
      }
    });

    // const level = {
    //   node: query.node,
    //   domain: config.url_dominio_microfwk,
    //   origin: config.origin,
    // };

    // this.isInfinite = false;
    // levelList(level, response => {

    //   const ItHasComponent = Utils.listInfiniteIsTrue(response.response);
    //   const modules =
    //     ItHasComponent &&
    //     response.response.modules.module[0].components.component;

    //   if (modules) {
    //     modules.map(it => {
    //       if (it.type === 'Listadoinfinito') {
    //         const paramsDefault = it.properties.url;
    //         this.__tempArgs = Utils.urlParamsToJson(paramsDefault);
    //         this.arrayOrder = it.properties.ordenamiento;
    //         this.setState({ level: it });
    //         this.isInfinite = true;
    //       }
    //     });
    //   }

    //   if (this.isInfinite) {
    //     this.setState({
    //       args: {
    //         ...this.__tempArgs,
    //         ...(!this.__tempArgs.quantity && { quantity: 40 }),
    //       },
    //     });

    //     if (this.arrayOrder.length !== 0) {
    //       this.setState({ order: HTMLDECODE(this.arrayOrder[0].order) });
    //     }
    //     const isNodeTV = _.get(node, 'layout', false);
    //     this.setState({ isNodeTV });

    //     // if (
    //     //   isNodeTV === constants.GUIA ||
    //     //   isNodeTV === constants.GUIDE_CHANNEL ||
    //     //   isNodeTV === constants.TV
    //     // ) {
    //     //   // const initDate = m().format('YYYYMMDDHH0000');
    //     //   // const range = {
    //     //   //   date_from: initDate,
    //     //   //   date_to: initDate,
    //     //   // };
    //     //   // fetchEpgChannel({
    //     //   //   range,
    //     //   // });
    //     // } else {
    //       infiniteListData(this.state.args, data => {
    //         this.setState({
    //           empty: data.response.groups.length,
    //           data: this.state.data.concat(data.response.groups),
    //           total: data.response.total,
    //         });
    //       });
    //     // }
    //   }
    // });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (this.state.isNodeTV === constants.GUIA ||
        this.state.isNodeTV === constants.GUIDE_CHANNEL ||
        this.state.isNodeTV === constants.TV) &&
      nextProps.epg.length > 0
    ) {
      this.setState({
        empty: nextProps.epg.length,
        data: nextProps.epg,
        total: nextProps.epg.length,
      });
    }
  }

  UNSAFE_componentWillMount() {
    this.claroRecording = JSON.parse(Utils.getCookie('claroRecording'));
  }

  back = () => {
    this.props.navigate(-1);
  };

  render() {
    let {
      country, node
    } = this.props?.query || {};
    const {
      infinite,
      config,
      user,
      isNewNavigation,
      showModal,
      location,
      metadata,
      translations,
      assetBarRecord,
      nav,
      query,
    } = this.props;
    node = node ? node.toLowerCase() : node ;
    const tvLive =
      node === constants.TV || (node === 'tvlineal' && country === 'argentina');

    const validateDataInfinite = () => {
      try {
        return Object.keys(infinite || {})?.length;
      } catch (error) {
        console.warn(error);
        return 0;
      }
    };

    if (tvLive && validateDataInfinite() === 0) {
      return <LoadingSpinner />;
    }

    if (!this.state.level) {
      return null;
    }

    const getPlayerUrl = () => {
      const deviceSO = Utils.getDeviceOS();
      const userId = getUserId();
      let player;

      if (config.urlPlayer[deviceSO]) {
        player = config.urlPlayer[deviceSO];
      } else {
        player = config.urlPlayer.default;
      }

      player += `${user.region}/`;
      return player;
    };

    const checkLiveRef = (item, key) => {
      const domain = getPlayerUrl();
      const userId = getUserId();
      const thirdProviderModal = {
        modalType: constants.SUSCRIPTION_CHANNEL,
        props: {
          message: constants.MODAL_FOX,
          item,
          isNewNavigation,
        },
      };

      if (Utils.MobileCheck()) {
        this.props.navigate(
          ClaroUrlBuilder.mobileGoToApp(GetRegion(), item.id, false),
        );
      }

      if (
        infinite?.[item?.id]?.live &&
        infinite?.[item?.id]?.live?.canPlay === 1
      ) {
        this.setMetrics(item, key);
        this.props.checkIfChannelIsBlocked({
          group_id: item?.id,
          onSuccess: () => this.props.navigate(`/${GetRegion()}${PLAYER_SEGMENT}${item.id}`),
        });
      } else {
        showModal(thirdProviderModal);
      }
    };

    const getOrderOptionText = order => {
      switch (order[0]) {
        case '100':
          if (order[1] === 'ASC') return 'a-z';
          return 'z-a';
        case '200':
          return 'lo mas nuevo';
        case '320':
          return 'lo mas visto';
        case '420':
          return 'lo mas votado';
        default:
          break;
      }
    };

    const onPlay = (item, live, key) => e => {
      e.preventDefault();
      e.stopPropagation();
      const split = this.props.location.pathname.split('/');
      const nodeSplit = split[2];

      if (
        live &&
        item.live_ref !== 'ppe' &&
        Object?.keys(infinite || [])?.length > 0
      ) {
        checkLiveRef(item, key);
      } else {
        const playerUrl = `/${user.region}/vcard/${nodeSplit}/${
          item.title_uri
        }/${item.id}`;
        this.setMetrics(item, key);

        const eventInfo = {
          event: 'select_content',
          content_section:
            item.proveedor_code === 'amco'
              ? 'subcategorias'
              : 'addon subcategorias',
          content_list: getOrderOptionText(this.state.orderOpt),
          content_id: item.id,
          content_name: item.title,
          content_type: '',
          content_category: '',
          content_availability: '',
        };
        this.props.navigate(playerUrl, {
          state: { eventInfo },
        });
      }
    };

    const onSel = () => {
      if (!tvLive) {
        return (
          <NavigationWrapper>
            <FiltersContainer
              ordenamiento={this.state.level.properties.ordenamiento}
              onChangePriorityOpt={this.handleChange}
            />
          </NavigationWrapper>
        );
      }
    };

    const loading = () => {
      if (this.state.empty !== 0 && this.state.args.from >= 40) {
        return (
          <div>
            <LoadingBlocks />
          </div>
        );
      }
    };

    const toggleConfig = metadata.filter_unavailable_channels
      ? JSON.parse(metadata.filter_unavailable_channels)
      : [];
    const toggleEnabled = toggleConfig[GetRegion()] || toggleConfig.default;
    console.log('pppppp')
    const card = this.state.data.map((value, key) => {
      const live = getContentListV1?.IsLive(value);

      const enabledChannel =
        infinite?.canPlay?.[value?.id] &&
        (infinite?.[value.id]?.live?.canPlay === 1) === 1;
      const layer =
        !enabledChannel && live && toggleEnabled.enabled_toggle ? 'layer' : '';
      const tooltip =
        this.state.currentTooltip && this.state.currentTooltip.id === value.id
          ? this.state.currentTooltip.tooltip
          : null;
      return (
        <div
          className="post"
          key={key}
          style={{ float: 'left', margin: '0 0 15px 5px', width: '300px' }}
        >
          <div className="jcarousel-item-1 jcarousel-item popover-active row">
            <div className="row" style={{ margin: '0' }}>
              <div className="col-sm-12 image">
                <div
                  className="item-wrapper"
                  onMouseOver={e => this.onHover(e, value, live)}
                >
                  <a
                    data-metricas-macroact=""
                    data-metricas-macrolab=""
                    data-metricas-macrocat=""
                    data-metricas-event=""
                    className="item-img"
                    onError={this.onImageError}
                    title={value.title}
                    onClick={onPlay(value, live, key)}
                  >
                    <img
                      alt={value.title}
                      src={value.image_small}
                      className="hidden-xs infiniteListImage"
                    />
                    <img
                      alt={value.title}
                      src={value.image_medium}
                      className="visible-xs"
                    />
                    <div className="item-hd">
                      <span>HD</span>
                    </div>
                    <div className="item-format item-format-right carrouselitem">
                      <span className="item-format-ppe" />
                    </div>
                    <PosterFormatType item={value} />
                    <PosterTitle resource={value} />
                    <span className={`play ${layer}`}>
                      <i className="fa fa-play-circle-o grid-channel-icon" />
                    </span>
                  </a>
                </div>
                {tooltip}
              </div>
            </div>
          </div>
        </div>
      );
    });
    let foxImage = (
      <div className="jcarousel jcarousel-2 horizontal fox clearfix">
        <div className="jcarousel-container jcarousel-container-1">
          <div className="jcarousel-item-1 jcarousel-item popover-active row">
            <div className="row">
              <div className=" col-sm-12 image" style={{ margin: '0' }}>
                <div className="item-wrapper">
                  <a className="item-img">
                    <img
                      className="foxnormal infinite_nav--img"
                      src={this.state.fox.image}
                      alt={this.state.fox.image}
                    />
                    <img
                      alt="fox"
                      className="foxover"
                      src={this.state.fox.image_over}
                      style={{ display: 'none' }}
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    let regresarBtn = (
      <a
        onClick={this.back}
        style={{
          textDecoration: 'none',
          margin: '0 5px',
          fontSize: '18px',
          cursor: 'pointer',
        }}
      >
        <span className="fa fa-arrow-left" />
        <span style={{ margin: '0 15px' }}>
          {converter.convertApa(translations, constants.TEXT_BUTTON_BACK)}
        </span>
      </a>
    );

    if (!this.state.isFox) {
      this.foxNodo(nav, false, query.node);
    }

    if (!this.state.isFox) {
      foxImage = null;
      regresarBtn = null;
    }
    return (
      <div className="infinite" style={{ margin: '0 auto' }}>
        <div style={{ marginTop: '10px' }} className="button-back">
          {regresarBtn}
        </div>
        <div className="nav menu-infinite">
          <SubMenu />
          {onSel()}
          {foxImage}
        </div>
        <div className="row card-infinite" style={{ minHeight: '100vh' }}>
          {card}
        </div>
        {this.claroRecording && (
          <RecordBarStatus
            show
            assetBarRecord={assetBarRecord}
            name={this.claroRecording.name}
            typeChannel={this.claroRecording.value}
          />
        )}
        {loading()}
      </div>
    );
  }
}

InfiniteList.propTypes = {
  config: PropTypes.object,
  user: PropTypes.object,
  query: PropTypes.object,
  translations: PropTypes.object,
  assets: PropTypes.object,
  node: PropTypes.object,
  nav: PropTypes.array,
  epg: PropTypes.object,
  infinite: PropTypes.object,
  setMetricsEvent: PropTypes.func.isRequired,
  infiniteListData: PropTypes.func.isRequired,
  fetchEpgChannel: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  currentNode: PropTypes.shape({
    code: PropTypes.string,
  }),
};

const mapStateToProps = state => ({
  config: state.config,
  metadata: state.metadata,
  user: state.user,
  translations: state.translations,
  contentData: state.card.contentData,
  infinite: state?.linealChannel?.data,
  assets: state.asset,
  epg: state.Player.EpgChannels?.data,
  paqsEnable: state?.infinite?.paqsEnable,
  assetBarRecord: getAssetBarRecord(state),
  nav: getNodesEnriched(state),
  node: getCurrentNode(state),
  currentNode: state.navigation.currentNode,
  isNewNavigation: getIsNewNavigation(state),
});

const mapDispatchToProps = dispatch => ({
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
  fetchEpgChannel(options, cb) {
    dispatch(fetchChannelsWithOptions(options, cb));
  },
  infiniteListData(args, cb) {
    dispatch(infinite?.infiniteListData(args, cb));
  },
  fetchPaywayLinealChannels(config, args, cb) {
    dispatch(infinite.fetchPaywayLinealChannels(config, args, cb));
  },
  setMetricsEvent(options) {
    dispatch(actionsMetrics.setMetricsEvent(options));
  },
  checkIfChannelIsBlocked(params) {
    dispatch(checkIfChannelIsBlocked(params));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InfiniteList);
